<template>
    <div class="swiper-container">
        <div class="swiper tyre-range-carousel">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="range in rangeList" :key="range.link.text">
                    <a target="_top" :href="range.link.url">
                        <img class="img-fluid" :src="getImageUrl(range.image.urls[0])" alt="" />
                        <div class="tyre-range-overlay"></div>
                        <span class="tyre-range-name text-uppercase text-center chevron-right-icon">{{range.link.text}}</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="swiper-button-next swiper-navigation-yellow"></div>
        <div class="swiper-button-prev swiper-navigation-yellow"></div>
    </div>
</template>

<script>
    import gql from 'graphql-tag';
    import Swiper from 'swiper';
    import SwiperCore, { Navigation, Pagination } from 'swiper/core';
    SwiperCore.use([Navigation, Pagination]);

    export default {
        data() {
            return {
                swiper: null,
                rangeList: [],
                cmsBaseUrl: process.env.VUE_APP_CMS_BASE_URL,
            }
        },
        computed: {
            getRangeList() {
                return this.blockCollection[0].blocks.contentItems;
            },
        },
        watch: {
            blockCollection: {
                handler() {
                    this.rangeList = this.getRangeList;
                    this.$nextTick(() => {
                        this.reinnitSwiper();
                    })
                }
            }
        },
        mounted() {
            this.swiper = new Swiper(".tyre-range-carousel", {
                slidesPerView: "auto",
                spaceBetween: 30,
                navigation: {
                    nextEl: "#HomeRange .swiper-button-next",
                    prevEl: "#HomeRange .swiper-button-prev",
                },
                breakpoints: {
                    992: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    }
                }
            });
        },
        apollo: {
            blockCollection: {
                query: gql`
                    {
                      blockCollection(where: {displayText: "Dunlop Range"}) {
                        blocks {
                          contentItems {
                            ... on BlockSingle {
                              image {
                                urls
                              }
                              link {
                                text
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                `,
            }
        },
        methods: {
            reinnitSwiper() {
                this.swiper.update();
            },
            getBaseUrl() {
                var IS_STAG = window.location.host.indexOf("inprogress") > -1 || window.location.host.indexOf("localhost") > -1;
                if (IS_STAG) this.cmsBaseUrl = 'https://dunloptyres-oc-qa.azurewebsites.net';

                return this.cmsBaseUrl;
            },
            getImageUrl(imagePath) {
                var fullPath = this.getBaseUrl() + imagePath;
                return fullPath;
            }
        }
    };
</script>